import styled from "@emotion/styled";
import React from "react";

import DesktopMenu from "./deskTopMenu";
import MobileMenu from "./mobileMenu";
import { MenuContainer } from "./styles";

const MenuList = [
  ["About Us", "/#aboutus"],
  ["Features", "/#features"],
  ["Tokenomics", "/#tokenomics"],
  ["Join Telegram", "https://t.me/flokigoldeth"],
];
const checkSticky = "";
const Menu = () => {
  return (
    <MenuContainer>
      <DesktopMenu menuList={MenuList} />
      <MobileMenu menuList={MenuList} />
    </MenuContainer>
  );
};

export default Menu;
